import { appRoutes } from '../../../shared/routes/app-routes';
import { AfterViewInit, Component, Input, OnInit, Renderer2 } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';
import { UserNotification } from '../../../shared/interfaces/userNotification';
import { HeaderService } from '../header.service';

@Component({
  selector: 'ss-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  standalone: false
})
export class NotificationsComponent implements OnInit, AfterViewInit {
  readonly appRoutes = appRoutes;
  @Input() username: string = '';
  isLoading: boolean = false;
  isShown: boolean = false;
  activeTab: 'all' | 'unread' = 'all';
  totalUnread$!: Observable<any>;
  notifications$!: Observable<UserNotification[]>;

  notifications: UserNotification[] = [];

  hasUnread: boolean = false;

  private _timeoutNotifications: any;
  private _currentPage = 0;
  private _lastPage = false;

  constructor(
    private headerService: HeaderService,
    private render: Renderer2) { }

  ngOnInit() {
    this.totalUnread$ = timer(0, 30000).pipe(
      switchMap(() => this.headerService.getTotalUnreadNotification()),
      shareReplay(1)
    );

    this.render.listen('document', 'click', (event) => {
      if (event.target.closest('#notifications') || event.target.closest('#notificationList')) { return; }

      if (this.isShown) {
        this.toggleNotifications();
      }
    });
  }

  ngAfterViewInit() {
    setInterval(() => {
      if (this._currentPage > 0) {
        this.getNotifications();
      }
    }, 30000);
  }

  get filteredNotifications(): UserNotification[] {
    if (this.activeTab === 'unread') {
      return (this.notifications || []).filter((n) => !n.was_read);
    }
    return this.notifications || [];
  }

  setTab(tab: 'all' | 'unread'): void {
    this.activeTab = tab;
  }

  notificationTitle(notification: UserNotification): string {
    const anyNotif = notification as any;
    if (anyNotif.title) {
      return anyNotif.title;
    }
    if (notification.link) {
      return 'Relatório disponível';
    }
    return 'Notificação';
  }

  toggleNotifications(): void {
    this.isShown = !this.isShown;
    if (this.isShown && this._currentPage === 0) {
      this.getNotifications();
    }
  }

  closeNotifications(): void {
    this.isShown = false;
  }

  getNotifications(): void {
    this.isLoading = true;
    const params: any = {};
    params['ordering'] = 'created_at:desc';
    params['by_user'] = this.username;
    this.headerService.getNotifications(params).subscribe((response: any) => {
      this.notifications = response.content || [];
      this.isLoading = false;

      this._currentPage = response.current_page;
      this._lastPage = this._currentPage == response.total_pages;
    }, (error: any) => {
      this.isLoading = false;
      console.log(error);
    });
  }

  setWasRead(id: any, wasRead: boolean, notification?: UserNotification): void {
    if (wasRead) { return; }

    this.headerService.readNotification(id).subscribe(() => {
      if (notification) {
        notification.was_read = true;
      } else {
        const target = this.notifications.find((n) => n.id === id);
        if (target) {
          target.was_read = true;
        }
      }
      this.totalUnread$ = this.headerService.getTotalUnreadNotification().pipe(shareReplay(1));
    }, (error: any) => {
      console.log(error);
    });
  }

  setAllread(): void {
    this.headerService.readAllNotifications().subscribe(() => {
      this.notifications.forEach(notification => notification.was_read = true);
      this.totalUnread$ = this.headerService.getTotalUnreadNotification().pipe(shareReplay(1));
    }, (error: any) => {
      console.log(error);
    });
  }

  onScroll(e: any): void {
    if (this._lastPage) return;

    clearTimeout(this._timeoutNotifications);
    this._timeoutNotifications = setTimeout(() => {
      if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight) {
        const params: any = {};
        params['ordering'] = 'created_at:desc';
        params['by_user'] = this.username;
        params['page'] = this._currentPage + 1;
        this.headerService.getNotifications(params).subscribe((response: any) => {
          this.notifications.push(...(response.content || []));
          this._currentPage = response.current_page;
          this._lastPage = this._currentPage == response.total_pages;
        }, (error: any) => {
          console.log(error);
        });
      }
    }, 500);
  }
}
